import { ROUTE_ADMIN_SERVERS, ROUTE_ADMIN_USERS } from './nombres'
import { defineRoutes } from '@utils/router'

/**
 * Definición de rutas con permisos de administrador
 */
export default defineRoutes([
    {
        path: '/v2/admin/usuarios',
        name: ROUTE_ADMIN_USERS,
        component: () => import('@views/pages/admin/usuarios'),
        meta: {
            title: 'i18n:sistemas.mantenimiento.usuarios.title',
            resource: 'Sistemas',
            action: 'ver-sistemas-mantenimiento-usuarios',
        },
    },
    {
        path: '/v2/admin/servidores',
        name: ROUTE_ADMIN_SERVERS,
        component: () => import('@views/pages/admin/servidores'),
        meta: {
            title: 'i18n:administracion-servidores',
            resource: 'Publico',
            action: 'ver-publico',
        },
    },
])
